var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "travelers-use-container" },
    [
      _vm.currentTravelRecordRow && _vm.currentTravelRecordRow.loginTimes
        ? _c(
            "el-dialog",
            {
              attrs: {
                "append-to-body": "",
                top: _vm.dialogTopMargin,
                title: _vm.currentTravelRecordRow.userName + "登入/登出紀錄",
                visible: _vm.dialogTravelersLoginRecordVisible,
                width: "40%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogTravelersLoginRecordVisible = $event
                },
              },
            },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { "overflow-y": "auto" },
                },
                [
                  _c("div", { staticStyle: { "max-height": "450px" } }, [
                    _c(
                      "div",
                      { staticStyle: { position: "relative", height: "100%" } },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.listLoading,
                                expression: "listLoading",
                              },
                            ],
                            attrs: {
                              size: "mini",
                              data: _vm.currentTravelRecordRow.loginTimes,
                              border: "",
                              fit: "",
                              "highlight-current-row": "",
                              height: "100%",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "項次",
                                width: "60",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.$index + 1)),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4178052834
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "登入日期" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.type == 1
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: "info",
                                                  effect: "plain",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      "" + scope.row.dateTime
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4044697736
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "登出日期" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.type == 2
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  effect: "plain",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      "" + scope.row.dateTime
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2966066206
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogTravelersLoginRecordVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentTravelRecordRow && _vm.currentTravelRecordRow.details
        ? _c(
            "el-dialog",
            {
              attrs: {
                "append-to-body": "",
                top: _vm.dialogTopMargin,
                title:
                  "【" +
                  _vm.currentTravelRecordRow.userName +
                  "】匯入/異動/取消紀錄",
                visible: _vm.dialogTravelersModifyRecordVisible,
                width: "50%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogTravelersModifyRecordVisible = $event
                },
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticStyle: { "": "450px" } }, [
                  _c(
                    "div",
                    { staticStyle: { position: "relative", height: "100%" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.listLoading,
                              expression: "listLoading",
                            },
                          ],
                          attrs: {
                            size: "mini",
                            data: _vm.currentTravelRecordRow.details,
                            border: "",
                            fit: "",
                            "highlight-current-row": "",
                            height: "100%",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "項次",
                              width: "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4178052834
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "異動項目",
                              width: "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.getTravelersModifyStatusStyle(
                                              scope.row.status
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                "" + scope.row.description
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4051338432
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作者",
                              width: "200",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.buildUserName) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              86551069
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "操作時間" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(scope.row.date) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2797572233
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogTravelersModifyRecordVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c("div", [
              _c(
                "div",
                { staticStyle: { position: "relative", height: "80%" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        data: _vm.travelersRecordList,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        height: "400px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "參團", width: "80" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: scope.row.include
                                        ? "success"
                                        : "danger",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "" + (scope.row.include ? "是" : "否")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "姓名" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(" " + _vm._s(scope.row.userName) + " "),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "登入次數",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.loginTimes &&
                                  scope.row.loginTimes.length > 0
                                  ? [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.partingLoginTime(
                                                scope.row.loginTimes,
                                                1
                                              ).length
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v("/"),
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.partingLoginTime(
                                                scope.row.loginTimes,
                                                2
                                              ).length
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "登入明細",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getLoginDetails(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("登入明細")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "匯入紀錄" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getModifyDetails(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("匯入紀錄")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }